import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { XIcon } from '@primer/octicons-react';
import { IdealCurvePoint } from '../models/IdealCurvePoint'

class IdealCurvePointEditor extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    point: PropTypes.instanceOf(IdealCurvePoint).isRequired,
  };

  _handleChangeX = (event) => {
    const { onChange, point } = this.props;

    let newPoint = IdealCurvePoint.copy(point);
    newPoint.x = event.target.value;

    onChange(newPoint);
  };

  _handleChangeY = (event) => {
    const { onChange, point } = this.props;

    let newPoint = IdealCurvePoint.copy(point);
    newPoint.y = event.target.value;

    onChange(newPoint);
  };

  _handleRemove = (event) => {
    const { onRemove, point } = this.props;

    event.preventDefault();
    onRemove(point);
  };

  _inErrorState = () => {
    const { point } = this.props;
    return (point.errorMessage != null && point.errorMessage.length > 0);
  };

  _errorInputClass = () => {
    if (this._inErrorState()) {
      return "is-invalid";
    } else {
      return "";
    }
  };

  render() {
    const { point } = this.props;

    return (
      <>
        <Row className="align-items-center">
          <Col className="p-1"><Form.Control aria-label="X" type="text" onChange={this._handleChangeX} value={point.x || ''} className={this._errorInputClass()} /></Col>
          <Col className="p-1"><Form.Control aria-label="Y" type="text" onChange={this._handleChangeY} value={point.y || ''} className={this._errorInputClass()} /></Col>
          <Col xs={1}>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip>Remove this point from the curve</Tooltip>}
            >
              <a aria-label='Remove Point' href="#" onClick={this._handleRemove}><XIcon /></a>
            </OverlayTrigger>
          </Col>
        </Row>
        {this._inErrorState() ? (<Row><Col className="errors p-1 mb-2">{point.errorMessage}</Col></Row>) : null}
      </>
    );
  }
}

export { IdealCurvePointEditor };
